import React, { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("bbs_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data.user))
      .catch(() => localStorage.removeItem("bbs_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("bbs_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("bbs_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const loginWithOtpResult = (data) => {
    localStorage.setItem("bbs_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const adminLogin = async (username, password) => {
    const { data } = await api.post("/auth/admin/login", { username, password });
    localStorage.setItem("bbs_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const kitchenLogin = async (username, password) => {
    const { data } = await api.post("/auth/kitchen/login", { username, password });
    localStorage.setItem("bbs_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const refreshUser = async () => {
    try { const r = await api.get("/auth/me"); setUser(r.data.user); return r.data.user; }
    catch (e) { return null; }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    localStorage.removeItem("bbs_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, loginWithOtpResult, adminLogin, kitchenLogin, refreshUser, formatApiError }}>
      {children}
    </AuthContext.Provider>
  );
}
